<div class="facet-list">
  @for (f of facets; track f.key) {
    <div class="facet" (click)="check(facetID, f.key)">
      <div>
        <input type="checkbox" [checked]="!!checks[f.key]" (click)="$event.preventDefault()">
      </div>
      <div class="global-text truncate">{{ names.hasOwnProperty(f.key) ? names[f.key].name : f.key }}</div>
      <div>{{ f.count }}</div>
    </div>
  }
</div>
